// import React, { useEffect, useState } from "react";
// import { Grid, Typography } from "@material-ui/core";

// import { makeStyles } from "@material-ui/core";
// import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
// import { fetchURL } from "../apiComponents/FetchComponent";

// import CardContent from "@material-ui/core/CardContent";
// import Modal from "@material-ui/core/Modal";
// import { IconButton } from "@material-ui/core";
// import CloseIcon from "@material-ui/icons/Close";
// import Nav from "./Nav";

// const useStyle = makeStyles((theme) => ({
//   container: {
//     boxShadow: " 0 5px 15px rgba(0, 0, 0, 0.2)",
//     padding: "15px",
//     margin: "20px",
//   },
//   head: {
//     display: "flex",
//   },
//   date: {
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     backgroundColor: "hsl(205,55%,50%)",
//     width: "60px",
//     height: "60px",
//     color: "white",
//   },
//   arrow: {
//     paddingLeft: "5px",
//     "&:hover": {
//       color: "hsl(205,78%,33%)",
//       transform: "translateX(.25rem)",
//     },
//   },
//   schedule: {
//     display: "flex",
//     justifyContent: "space-between",
//   },
//   main: {
//     position: "fixed",
//     width: "80%",
//     margin: "5%",
//     justifyContent: "center",
//     backgroundColor: "white",
//     borderRadius: 12,
//   },
//   nav: {
//     padding:'30px',
//   }
// }));

// const Announcement = () => {
//   const classes = useStyle();
//   const [artics, setArtics] = useState({ results: [] });
//   const [loading, setLoading] = useState(true);
//   const [modalIndex, setModalIndex] = useState({});
//   const [modalShow, setModalShow] = useState(false);

//   useEffect(() => {
//     const getData = async () => {
//       let { loading, data } = await fetchURL(
//         "https://backend.missionoxygenteam.org/about/api/resource/announcement/en/"
//       );

//       // setArtics(data);
//       // setLoading(loading);
//     };

//     getData();
//   }, []);

//   const handleClick = (id) => {
//     setModalIndex(artics.results.filter((data) => data.id == id)[0]);
//     setModalShow(true);
//     console.log(modalIndex);
//   };

//   const handleClose = () => {
//     setModalShow(false);
//   };

//   const body = (
//     <div>
//       {modalIndex && (
//         <Grid
//           key={modalIndex.id}
//           className={classes.main}
//           style={{ height: "80%", overflowY: "scroll" }}
//         >
//           <div className="container">
//             <CardContent className={classes.scroll}>
//               <IconButton
//                 aria-label="close"
//                 onClick={handleClose}
//                 style={{ float: "right" }}
//               >
//                 <CloseIcon />
//               </IconButton>
//             </CardContent>
//             <div className={classes.head}>
//               <div className={classes.date}>
//                 <span>{modalIndex.created_date}</span>
//               </div>
//               <div
//                 style={{
//                   paddingLeft: "15px",
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 <b>{modalIndex.title}</b>
//               </div>
//             </div>
//             <div style={{ paddingTop: "10px" }}>
//               <p>{modalIndex.content}</p>
//             </div>
//             <div className={classes.schedule}>
//               <div>
//                 {/* time duretion */}

//                 <span>{modalIndex.slug}</span>
//               </div>
//             </div>
//           </div>
//         </Grid>
//       )}
//     </div>
//   );

//   const date = [];

//   return (
//     <>
//     <div className={classes.root}>
//     <div className={classes.nav}><Nav></Nav></div>
//       <div>
//         {modalIndex && (
//           <Modal open={modalShow} onClose={handleClose}>
//             {modalIndex && body}
//           </Modal>
//         )}
//       </div>

//       {loading && <Typography> Loading...</Typography>}
//       <Typography
//         variant="h5"
//         style={{
//           color: "hsl(205,78%,33%)",
//           display: "flex",
//           justifyContent: "center",
//           margin: "2% 0",
//         }}
//       >
//         Announcements
//       </Typography>

//       {artics.results.map((item) => {
//         if (
//           item.title !== "सहयोगको लागि कसरी निवेदन दिने" &&
//           item.category === "AN"
//         ) {
//           date.push(item.created_date);
//           return (
//             <Grid key={item.id} className={classes.container}>
//               <div className={classes.head}>
//                 <div className={classes.date}>
//                   <span>{item.created_date}</span>
//                 </div>
//                 <div
//                   style={{
//                     paddingLeft: "15px",
//                     display: "flex",
//                     alignItems: "center",
//                   }}
//                 >
//                   <b>{item.title}</b>
//                 </div>
//               </div>
//               <div style={{ paddingTop: "10px" }}>
//                 <p>{item.content}</p>
//               </div>
//               <div
//                 className={classes.schedule}
//                 onClick={() => handleClick(item.id)}
//               >
//                 <div
//                   className={classes.arrow}
//                   style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     cursor: "pointer",
//                   }}
//                 >
//                   {/* <Link
//                     to="/newsresource/announcement/allannouncement"
//                     style={{ textDecoration: "none" }}
//                   > */}
//                   Learn More.
//                   <ArrowRightAltIcon style={{ paddingTop: "2px" }} />
//                   {/* </Link> */}
//                 </div>
//                 <div>
//                   {/* time duretion */}

//                   <span>{item.slug}</span>
//                 </div>
//               </div>
//             </Grid>
//           );
//         }
//       })}
//     </div>
//     </>
//   );
// };

// export default Announcement;


import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import Nav from './Nav';

const useStyle = makeStyles((theme) => ({
  main: {
    padding: "30px",
  },
  cards: {
    display: "flex",

    flexWrap: "wrap",
    justifyContent: "space-evenly",
    cursor: "pointer",
  },

  container: {
    boxShadow: " 0 15px 20px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      boxShadow: " 0 5px 15px rgba(0, 0, 0, 0.2)",
    },
    padding: "15px",
    width: "250px",
    margin: "20px",
  },
  image: {
    height: "150px",
    width: "220px",
  },
  datelogo: {
    paddingTop: "18px",
    height: "40px",
    width: "20px",
  },
  datecontainer: {
    display: "flex",
  },
  newsTitle: {
    color: "hsl(205,78%,33%)",
  },
}));

const News = () => {
  const classes = useStyle();
  return (
    <div className={classes.main}>
      <Nav></Nav>
      <div>
        <Typography
          variant="h5"
          style={{
            color: "hsl(205,78%,33%)",
            display: "flex",
            justifyContent: "center",
            margin: "2% 0",
          }}
        >
          Announcements
        </Typography>

        <p
          style={{
            marginTop: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          MOT members are actively engaged in different activities, This page
          shows the Announcement related to MOT
          operation
        </p>
      </div>
      <div className={classes.cards}>
        <div className={classes.container}>
        <video autoPlay muted loop className={classes.image} >
       <source src="/Announcement.mp4" type="video/mp4"/>
   </video >
          <div className={classes.datecontainer}>
            <img
              src="https://img.icons8.com/small/32/000000/date-span.png"
              alt="date"
              className={classes.datelogo}
            />
            <p style={{ paddingTop: "15px" }}> 21 july 2022</p>
          </div>
          <div className={classes.newsTitle}>
            <b style={{ fontWeight: "20rem" }}><a href="https://fb.watch/fJ9AsJdZ_u/">Mission Oxygen Team[MOT] is providing hands-on training on biomedical equipment to biomedical Engineers in support of UNDP. MOT brings its second training for the biomedical engineers of Kathmandu from Bagmati Province</a></b>
          </div>
        </div>

        <div className={classes.container}>
        <video autoPlay muted loop className={classes.image} >
       <source src="/Announcement2.mp4" type="video/mp4"/>
      </video>
          <div className={classes.datecontainer}>
            <img
              src="https://img.icons8.com/small/32/000000/date-span.png"
              alt="date"
              className={classes.datelogo}
            />
            <p style={{ paddingTop: "15px" }}> 15 July 2022</p>
          </div>
          <div className={classes.newsTitle}>
            <b style={{ fontWeight: "20rem" }}><a href="https://fb.watch/fJ9qCjeZ7p/">Mission Oxygen Team[MOT] is providing hands-on training on biomedical equipment to biomedical Engineers in support of UNDP. This is one of the first of its kind happening here in Lumbini Province</a></b>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default News;
